var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoveItem = function SvgMoveItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "move_item_svg__a",
    width: 23,
    height: 23,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h23v23H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#move_item_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M19.524 12.22H8.94a.7.7 0 0 1-.513-.206.7.7 0 0 1-.206-.513q0-.306.206-.512a.7.7 0 0 1 .513-.206h10.584l-1.239-1.239a.68.68 0 0 1-.21-.5.74.74 0 0 1 .21-.51.73.73 0 0 1 .512-.23.68.68 0 0 1 .513.215l2.375 2.376a.83.83 0 0 1 .26.606.83.83 0 0 1-.26.607l-2.375 2.375a.68.68 0 0 1-.508.211.72.72 0 0 1-.517-.226.75.75 0 0 1-.215-.505.67.67 0 0 1 .215-.504zM14.57 7.779V5.088a.29.29 0 0 0-.083-.212.29.29 0 0 0-.212-.083H5.088a.29.29 0 0 0-.212.083.29.29 0 0 0-.083.212v12.827q0 .128.083.212a.29.29 0 0 0 .212.083h9.187a.29.29 0 0 0 .212-.083.29.29 0 0 0 .083-.212v-2.691q0-.306.206-.512a.7.7 0 0 1 .513-.207q.306 0 .512.207a.7.7 0 0 1 .206.512v2.69q0 .718-.508 1.225a1.67 1.67 0 0 1-1.224.508H5.088q-.717 0-1.225-.508a1.67 1.67 0 0 1-.508-1.224V5.088q0-.717.508-1.225a1.67 1.67 0 0 1 1.225-.508h9.187q.717 0 1.224.508.508.508.508 1.225v2.69a.7.7 0 0 1-.206.513.7.7 0 0 1-.512.206.7.7 0 0 1-.513-.206.7.7 0 0 1-.206-.512"
  }))));
};
export default SvgMoveItem;